import { createSlice } from '@reduxjs/toolkit';
import { startLoadingReducer, stopLoadingReducer } from './changePasswordReducers';

export interface ChangePasswordState {
  loading: boolean;
}

const initialState: ChangePasswordState = {
  loading: false,
};

const changePasswordSlice = createSlice({
  name: 'ChangePassword',
  initialState,
  reducers: {
    startLoading: startLoadingReducer,
    stopLoading: stopLoadingReducer,
  },
});

export const { startLoading, stopLoading } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
